<template>
    <div class="linkEvent">
        <span class="btnsimple" @click="$modal.show('openLink')">
            <i class="fas fa-qrcode"></i>
            Qr Code / Url
        </span>
        <modal name="openLink"
            height="auto"
            v-bind:click-to-close="true"
        >
            <div class="card">
            <div class="card-body">
                    <button @click="$modal.hide('openLink')" class="closeIcon" style=""><span></span></button>
                <h3>Code Qr / Link </h3>
                <p>Aqui van las opciones</p>
                <button @click="$modal.hide('background_photo')">Close</button>
            </div>
            </div>
        </modal>
    </div>
</template>
<script>
export default {
    name: "linkEvent",
    props: {
        delay: {
            type: [Number, String],
            default: 0,
        },
    },
};
</script>
<style lang="scss" scoped>
.btnsimple {
    border: 1px solid rgba(0, 0, 0, 0.25);
    padding: 3px 5px;
    cursor: pointer;
}
</style>
